module.exports = __webpack_public_path__ + "img/kontakt.f5b5face.jpg";